var exports = {
  "UH": "stateLabel__opcfNS",
  "t": "duplicateIssueLink__7ybcp0",
  "eA": "duplicateIssueLinkOutside__BdyNra",
  "II": "statusContainer__IMnUX3",
  "rI": "statusButton__igaeXP",
  "Ew": "statusCaret__cA6rOa",
  "k8": "statusLabelIcon__ARJYXr",
};

module.exports = exports;
